import articleProyect from './proyect'

export const sectionProyects = (state) => `
<section id='proyect' class='wrapper pb-6'>
    <h3 class='pt-6 pb-6'>${state.ProyectoTitle}</h3>

        ${state.proyects
        .map((proyect, index, array) =>
            articleProyect(
                array.length,
                index,
                proyect.urlImageProyect,
                proyect.titleProyect,
                proyect.age,
                proyect.copyProyect,
                proyect.technologies,
                proyect.urlCode,
                proyect.urlDemo
            )
        )
        .join('')}
        
    
    
</section>`
